import { render, staticRenderFns } from "./Statistical.vue?vue&type=template&id=44a84479"
import script from "./Statistical.vue?vue&type=script&lang=js"
export * from "./Statistical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports